"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manitobaCities = void 0;
exports.manitobaCities = [
    {
        label: "Alexander, MB",
        value: 5011,
    },
    {
        label: "Altona",
        value: 5010,
    },
    {
        label: "Anola, MB",
        value: 5013,
    },
    {
        label: "Arborg",
        value: 5012,
    },
    {
        label: "Arden",
        value: 5014,
    },
    {
        label: "Arnaud",
        value: 5016,
    },
    {
        label: "Arnes",
        value: 5018,
    },
    {
        label: "Ashern",
        value: 5107,
    },
    {
        label: "Ashville",
        value: 5020,
    },
    {
        label: "Austin",
        value: 5022,
    },
    {
        label: "Bagot",
        value: 5108,
    },
    {
        label: "Baldur",
        value: 5029,
    },
    {
        label: "Balmoral",
        value: 5109,
    },
    {
        label: "Barrows",
        value: 5028,
    },
    {
        label: "Beausejour",
        value: 5030,
    },
    {
        label: "Belmont, MB",
        value: 5031,
    },
    {
        label: "Benito",
        value: 5032,
    },
    {
        label: "Binscarth",
        value: 5034,
    },
    {
        label: "Birtle",
        value: 5036,
    },
    {
        label: "Bloodvein River",
        value: 5037,
    },
    {
        label: "Blumenort",
        value: 5039,
    },
    {
        label: "Boissevain",
        value: 5038,
    },
    {
        label: "Bowsman",
        value: 5040,
    },
    {
        label: "Brandon",
        value: 5042,
    },
    {
        label: "Brunkild",
        value: 5110,
    },
    {
        label: "Bruxelles",
        value: 5111,
    },
    {
        label: "Carberry",
        value: 5060,
    },
    {
        label: "Carman",
        value: 5062,
    },
    {
        label: "Cartier",
        value: 5112,
    },
    {
        label: "Cartwright",
        value: 5064,
    },
    {
        label: "Churchill",
        value: 5065,
    },
    {
        label: "Clandeboye",
        value: 5407,
    },
    {
        label: "Coulter",
        value: 5067,
    },
    {
        label: "Cross Lake",
        value: 5113,
    },
    {
        label: "Crystal City",
        value: 5066,
    },
    {
        label: "Dauphin",
        value: 5080,
    },
    {
        label: "Decker",
        value: 5081,
    },
    {
        label: "Deloraine",
        value: 5082,
    },
    {
        label: "Dominion City",
        value: 5083,
    },
    {
        label: "Dufresne",
        value: 5033,
    },
    {
        label: "Dugald, MB",
        value: 5015,
    },
    {
        label: "Dunnottar",
        value: 5084,
    },
    {
        label: "Durban",
        value: 5088,
    },
    {
        label: "East Kildonan",
        value: 5380,
    },
    {
        label: "East Landmark",
        value: 5092,
    },
    {
        label: "East St Paul",
        value: 5381,
    },
    {
        label: "Elgin, MB",
        value: 5099,
    },
    {
        label: "Elie",
        value: 5098,
    },
    {
        label: "Elkhorn",
        value: 5100,
    },
    {
        label: "Elma",
        value: 5101,
    },
    {
        label: "Elmer",
        value: 5103,
    },
    {
        label: "Emerson",
        value: 5102,
    },
    {
        label: "Erickson, MB",
        value: 5104,
    },
    {
        label: "Eriksdale",
        value: 5105,
    },
    {
        label: "Ethelbert",
        value: 5106,
    },
    {
        label: "Fisher Branch",
        value: 5118,
    },
    {
        label: "Flin Flon",
        value: 5120,
    },
    {
        label: "Gardenhill",
        value: 5114,
    },
    {
        label: "Garson, MB",
        value: 5130,
    },
    {
        label: "Gilbert Plains",
        value: 5132,
    },
    {
        label: "Gillam",
        value: 5133,
    },
    {
        label: "Gimli",
        value: 5134,
    },
    {
        label: "Gladstone",
        value: 5136,
    },
    {
        label: "Glenboro",
        value: 5138,
    },
    {
        label: "Goodlands",
        value: 5139,
    },
    {
        label: "Grand Rapids",
        value: 5141,
    },
    {
        label: "Grande Pointe",
        value: 5097,
    },
    {
        label: "Grandview, MB",
        value: 5140,
    },
    {
        label: "Graysville",
        value: 5115,
    },
    {
        label: "Great Falls",
        value: 5142,
    },
    {
        label: "Gretna",
        value: 5144,
    },
    {
        label: "Grosse Isle",
        value: 5116,
    },
    {
        label: "Grunthal",
        value: 5146,
    },
    {
        label: "Gypsumville",
        value: 5117,
    },
    {
        label: "Hadashville",
        value: 5147,
    },
    {
        label: "Hamilton, MB",
        value: 5158,
    },
    {
        label: "Hamiota",
        value: 5160,
    },
    {
        label: "Hartney",
        value: 5162,
    },
    {
        label: "Haywood",
        value: 5163,
    },
    {
        label: "Headingley",
        value: 5164,
    },
    {
        label: "Hilbre",
        value: 5161,
    },
    {
        label: "Holland",
        value: 5148,
    },
    {
        label: "Horndean",
        value: 5165,
    },
    {
        label: "Hudgson",
        value: 5166,
    },
    {
        label: "Ãle-des-ChÃªnes",
        value: 5171,
    },
    {
        label: "Island Lake, MB",
        value: 5150,
    },
    {
        label: "Kelwood",
        value: 5151,
    },
    {
        label: "Kenton",
        value: 5167,
    },
    {
        label: "Kenville, MB",
        value: 5168,
    },
    {
        label: "Killarney",
        value: 5170,
    },
    {
        label: "Kirkella",
        value: 5408,
    },
    {
        label: "Kleefeld",
        value: 5169,
    },
    {
        label: "Kola",
        value: 5086,
    },
    {
        label: "Komarno",
        value: 5178,
    },
    {
        label: "La Broquerie, MB",
        value: 5192,
    },
    {
        label: "La Salle, MB",
        value: 5090,
    },
    {
        label: "Lac du Bonnet",
        value: 5190,
    },
    {
        label: "Landmark",
        value: 5189,
    },
    {
        label: "La-Riviere",
        value: 5191,
    },
    {
        label: "Leaf Rapids",
        value: 5193,
    },
    {
        label: "Lena",
        value: 5194,
    },
    {
        label: "Libau",
        value: 5188,
    },
    {
        label: "Lindenwoods",
        value: 5198,
    },
    {
        label: "Lockport",
        value: 5152,
    },
    {
        label: "Lorette, MB",
        value: 5094,
    },
    {
        label: "Lowe Farm",
        value: 5195,
    },
    {
        label: "Lundar",
        value: 5409,
    },
    {
        label: "Lyleton",
        value: 5196,
    },
    {
        label: "Lynn Lake",
        value: 5197,
    },
    {
        label: "MacGregor",
        value: 5200,
    },
    {
        label: "Manitou",
        value: 5204,
    },
    {
        label: "Manson, MB",
        value: 5017,
    },
    {
        label: "Marchand",
        value: 5044,
    },
    {
        label: "Marquette",
        value: 5173,
    },
    {
        label: "Matlock",
        value: 5153,
    },
    {
        label: "McAuley",
        value: 5019,
    },
    {
        label: "McCreary",
        value: 5206,
    },
    {
        label: "Melita",
        value: 5208,
    },
    {
        label: "Miami",
        value: 5410,
    },
    {
        label: "Middlebro",
        value: 5209,
    },
    {
        label: "Miniolta",
        value: 5211,
    },
    {
        label: "Minitonas",
        value: 5210,
    },
    {
        label: "Minnedosa",
        value: 5212,
    },
    {
        label: "Minto, MB",
        value: 5215,
    },
    {
        label: "Mitchell, MB",
        value: 5096,
    },
    {
        label: "Moar Lake",
        value: 5213,
    },
    {
        label: "Morden",
        value: 5214,
    },
    {
        label: "Morris",
        value: 5216,
    },
    {
        label: "Napinka",
        value: 5230,
    },
    {
        label: "Neepawa",
        value: 5232,
    },
    {
        label: "New Bothwell",
        value: 5122,
    },
    {
        label: "Newdale",
        value: 5231,
    },
    {
        label: "Ninette",
        value: 5154,
    },
    {
        label: "Niverville",
        value: 5234,
    },
    {
        label: "North Kildonan",
        value: 5174,
    },
    {
        label: "Norway House",
        value: 5235,
    },
    {
        label: "Notre Dame de Lou",
        value: 5236,
    },
    {
        label: "Oak Lake",
        value: 5244,
    },
    {
        label: "Oakbank, MB",
        value: 5021,
    },
    {
        label: "Onanole",
        value: 5155,
    },
    {
        label: "Other",
        value: 5799,
    },
    {
        label: "Otterburne, MB",
        value: 5246,
    },
    {
        label: "Pierson",
        value: 5257,
    },
    {
        label: "Pilot Mound",
        value: 5260,
    },
    {
        label: "Pinawa",
        value: 5259,
    },
    {
        label: "Pine Falls",
        value: 5411,
    },
    {
        label: "Pine River",
        value: 5048,
    },
    {
        label: "Piney",
        value: 5261,
    },
    {
        label: "Pipestone",
        value: 5258,
    },
    {
        label: "Plum Coulee",
        value: 5262,
    },
    {
        label: "Plumas",
        value: 5156,
    },
    {
        label: "Poplar Point",
        value: 5263,
    },
    {
        label: "Poplarfield",
        value: 5175,
    },
    {
        label: "Portage la Prairi",
        value: 5264,
    },
    {
        label: "Powerview",
        value: 5266,
    },
    {
        label: "Prawda",
        value: 5157,
    },
    {
        label: "Randolf",
        value: 5277,
    },
    {
        label: "Rapid City",
        value: 5280,
    },
    {
        label: "Red Sucker Lake",
        value: 5278,
    },
    {
        label: "Reinfeld",
        value: 5026,
    },
    {
        label: "Reston",
        value: 5283,
    },
    {
        label: "Richer",
        value: 5279,
    },
    {
        label: "Ritchot",
        value: 5281,
    },
    {
        label: "Rivers",
        value: 5282,
    },
    {
        label: "Riverton",
        value: 5284,
    },
    {
        label: "Roblin",
        value: 5286,
    },
    {
        label: "Roland",
        value: 5285,
    },
    {
        label: "Rorketon",
        value: 5287,
    },
    {
        label: "Roseisle",
        value: 5293,
    },
    {
        label: "Rosenfeld",
        value: 5289,
    },
    {
        label: "Rosenort",
        value: 5292,
    },
    {
        label: "Rossburn",
        value: 5288,
    },
    {
        label: "Rossendale",
        value: 5291,
    },
    {
        label: "Russell, MB",
        value: 5290,
    },
    {
        label: "Saint Adolphe",
        value: 5412,
    },
    {
        label: "Saint Claude",
        value: 5310,
    },
    {
        label: "Saint FranÃ§ois Xavier",
        value: 5383,
    },
    {
        label: "Saint Martin",
        value: 5315,
    },
    {
        label: "Sandy Hook",
        value: 5295,
    },
    {
        label: "Sarto",
        value: 5159,
    },
    {
        label: "Schanzenfeld",
        value: 5035,
    },
    {
        label: "Selkirk",
        value: 5300,
    },
    {
        label: "Shamattawa",
        value: 5296,
    },
    {
        label: "Shilo",
        value: 5301,
    },
    {
        label: "Shoal Lake",
        value: 5302,
    },
    {
        label: "Shortdale",
        value: 5297,
    },
    {
        label: "Snow Lake",
        value: 5303,
    },
    {
        label: "Snowflake",
        value: 5305,
    },
    {
        label: "Somerset",
        value: 5304,
    },
    {
        label: "Souris, MB",
        value: 5306,
    },
    {
        label: "South Junction",
        value: 5308,
    },
    {
        label: "Sprague",
        value: 5309,
    },
    {
        label: "Springfield, MB",
        value: 5307,
    },
    {
        label: "St Andrews, MB",
        value: 5124,
    },
    {
        label: "St Boniface, MB",
        value: 5382,
    },
    {
        label: "St Germain",
        value: 5311,
    },
    {
        label: "St Laurent, MB",
        value: 5312,
    },
    {
        label: "St Vital",
        value: 5386,
    },
    {
        label: "St. James-Assiniboia",
        value: 5384,
    },
    {
        label: "St. Jean",
        value: 5046,
    },
    {
        label: "St. Malo",
        value: 5317,
    },
    {
        label: "St.-Pierre-Jolys",
        value: 5313,
    },
    {
        label: "Starbuck",
        value: 5404,
    },
    {
        label: "Ste Agatha, MB",
        value: 5318,
    },
    {
        label: "Ste Anne",
        value: 5320,
    },
    {
        label: "Ste Rose du Lac",
        value: 5321,
    },
    {
        label: "Steinbach",
        value: 5322,
    },
    {
        label: "St-Lazare",
        value: 5314,
    },
    {
        label: "Stonewall",
        value: 5324,
    },
    {
        label: "Stoney Mountain",
        value: 5406,
    },
    {
        label: "Strathclair",
        value: 5323,
    },
    {
        label: "Sundance",
        value: 5325,
    },
    {
        label: "Sundown",
        value: 5413,
    },
    {
        label: "Swan Lake",
        value: 5414,
    },
    {
        label: "Swan River",
        value: 5326,
    },
    {
        label: "Teulon",
        value: 5340,
    },
    {
        label: "The Pas",
        value: 5342,
    },
    {
        label: "Thicket Portage",
        value: 5176,
    },
    {
        label: "Thompson, MB",
        value: 5344,
    },
    {
        label: "Tolstol",
        value: 5345,
    },
    {
        label: "Tourand",
        value: 5346,
    },
    {
        label: "Transcona",
        value: 5388,
    },
    {
        label: "Treherne",
        value: 5348,
    },
    {
        label: "Tuxedo",
        value: 5390,
    },
    {
        label: "Tyndall",
        value: 5024,
    },
    {
        label: "Vermette",
        value: 5358,
    },
    {
        label: "Virden",
        value: 5360,
    },
    {
        label: "Vita",
        value: 5362,
    },
    {
        label: "Warren, MB",
        value: 5177,
    },
    {
        label: "Waskada",
        value: 5370,
    },
    {
        label: "Waterhen",
        value: 5368,
    },
    {
        label: "Wawanesa",
        value: 5372,
    },
    {
        label: "Waywayseecappo",
        value: 5068,
    },
    {
        label: "Wellwood",
        value: 5205,
    },
    {
        label: "West Kildonan",
        value: 5392,
    },
    {
        label: "West St Paul",
        value: 5393,
    },
    {
        label: "Whitemouth",
        value: 5373,
    },
    {
        label: "Windygate",
        value: 5375,
    },
    {
        label: "Winkler",
        value: 5376,
    },
    {
        label: "Winnipeg",
        value: 5378,
    },
    {
        label: "Winnipeg Beach",
        value: 5400,
    },
    {
        label: "Winnipegosis",
        value: 5402,
    },
    {
        label: "Woodlands",
        value: 5379,
    },
    {
        label: "Woodmore",
        value: 5172,
    },
    {
        label: "Zhoda, MB",
        value: 5023,
    },
];
